<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="4">
          <h4>{{ $t("ration.prepareRelation") }}</h4>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="4" class="text-center">
          <p v-if="rationType == 'system'">
            Step 1 of 2 | {{ $t("ration.animalSelection") }}
          </p>
          <p v-else>Step 1 of 3 | {{ $t("ration.animalSelection") }}</p>
        </v-col>
        <v-spacer></v-spacer>

        <v-col cols="4" class="text-right">
          <v-btn outlined color="primary" class="mr-2" @click="back">
            Back
          </v-btn>
          <v-btn
            color="primary"
            v-if="rationType == 'system'"
            @click="isRationSuggestion = true"
          >
            Next
          </v-btn>
          <v-btn color="primary" v-else @click="next"> Next </v-btn>
        </v-col>
      </v-row>
      <v-divider class="my-4"></v-divider>
      <v-row class="pt-4 pb-6">
        <v-col cols="6">
          <h3>
            {{ $t("ration.selectGroup") }}
            <span class="green--text" style="font-size: 14px"
              >{{ selectedAnimalGroups?.length || 0 }}
              {{ $t("ration.groupSelected") }}
            </span>
          </h3>
        </v-col>
        <v-col cols="6">
          <v-btn
            class="float-right"
            color="primary"
            @click="unGroupedAnimals = true"
          >
            {{ $t("ration.addNewGroup") }}
          </v-btn>
        </v-col>
      </v-row>
      <v-card elevation="0" class="px-5">
        <v-card-text>
          <!-- DATA TABLE STARS HERE -->
          <v-data-table
            :headers="tableHeaders"
            :items="items"
            :items-per-page="10"
            :loading="loading"
            loading-text="Loading Animal Group... Please wait"
            hide-default-footer
            :header-props="{
              'sort-icon': 'mdi-unfold-more-horizontal',
            }"
            :single-expand="singleExpand"
            :expanded.sync="expanded"
            show-expand
            item-key="id"
          >
            <template v-slot:top>
              <div>
                <!-- SEARCH, FILTER & PAGINATION HERE -->

                <div class="d-flex mt-3">
                  <v-text-field
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    height="5px"
                    placeholder="Search"
                    dense
                    v-model="search"
                    class="shrink"
                  ></v-text-field>
                  <v-btn
                    :disabled="search.length < 1"
                    color="primary"
                    height="40"
                    width="40"
                    max-width="40"
                    outlined
                    class="ml-8 mr-3"
                    @click="searchAnimals"
                  >
                    <v-icon>mdi-filter-outline</v-icon>
                  </v-btn>

                  <v-spacer></v-spacer>
                  <div class="py-3">
                    {{ tableOptions.page }} of {{ totalPages }}
                  </div>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    :disabled="tableOptions.page <= 1"
                    @click="pageChange(false)"
                  >
                    <v-icon dark> mdi-chevron-left </v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    :disabled="tableOptions.page >= totalPages"
                    @click="pageChange(true)"
                  >
                    <v-icon dark> mdi-chevron-right </v-icon>
                  </v-btn>
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    left
                    :min-width="417"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark> mdi-cog-outline </v-icon>
                      </v-btn>
                    </template>

                    <v-card width="417">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              $t("farm.customization")
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div class="pl-3 pt-2 font-weight-normal">
                          {{ $t("farm.recordsPerpage") }}
                        </div>
                        <v-list-item>
                          <v-list-item-content>
                            <v-slider
                              v-model="itemsPerPageSlider"
                              :tick-labels="itemsPerPageOptions"
                              :max="3"
                              step="1"
                              ticks="always"
                              tick-size="4"
                            ></v-slider>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-n3"></v-divider>
                      </v-list>
                      <v-card-text>
                        <v-container fluid>
                          <v-row>
                            <v-col
                              class="mt-n9"
                              cols="6"
                              v-for="header in headers"
                              :key="header.value"
                            >
                              <v-checkbox
                                v-model="selectedHeaders"
                                :label="header.text"
                                color="primary"
                                :value="header.text"
                                hide-details
                                :disabled="
                                  header.text == 'ID' || header.text == 'Tag'
                                "
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-layout justify-center>
                        <v-card-actions class="mb-5">
                          <v-spacer></v-spacer>

                          <v-btn
                            outlined
                            color="primary"
                            width="190"
                            @click="resetDefaut"
                          >
                            {{ $t("farm.restoreDefault") }}
                          </v-btn>
                          <v-btn color="primary" @click="resetTableStructure">
                            {{ $t("farm.apply") }}
                          </v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-card>
                  </v-menu>
                </div>
                <!-- QUICKS FILTERS -->
                <template>
                  <v-row
                    justify="space-around"
                    class="d-flex mt-3 mb-8 mx-0 pa-0"
                    style="background: #fff7ec; border-radius: 4px"
                  >
                    <v-col
                      cols="2"
                      lg="1"
                      md="2"
                      class="pa-0 d-flex align-center"
                    >
                      <h4
                        class="px-3 pr-6"
                        style="border-right: 1px solid #1e1e1e"
                      >
                        {{ $t("ration.quickFilters") }}
                      </h4>
                    </v-col>
                    <v-col cols="10" lg="11" md="10" class="pa-0">
                      <v-sheet color="#fff7ec">
                        <v-chip-group
                          class="overflow-x:auto;white-space:nowrap"
                          show-arrows="true"
                        >
                          <v-chip
                            v-for="item in filterList"
                            :key="item.value"
                            class="ma-2"
                            color="green"
                            outlined
                            style="background-color: #fff !important"
                            @click="applyQuickFilter(item)"
                          >
                            <span class="black--text">
                              {{ item.displayName }}</span
                            >
                          </v-chip>
                        </v-chip-group>
                      </v-sheet>
                    </v-col>
                  </v-row>
                </template>
              </div>
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="primary"
                :height="8"
                indeterminate
              ></v-progress-linear>
            </template>
            <template #item.data-table-expand="{ item, expand, isExpanded }">
              <td>
                <v-checkbox
                  v-model="item.checked"
                  @click="openDubGroupModal(item)"
                ></v-checkbox>
              </td>
              <td class="text-start">
                <v-btn
                  icon
                  @click="expand(!isExpanded)"
                  class="v-data-table__expand-icon"
                  :class="{ 'v-data-table__expand-icon--active': isExpanded }"
                >
                  <v-icon color="green" v-if="!isExpanded"
                    >mdi-plus-box-outline</v-icon
                  >
                  <v-icon color="green" v-else>mdi-minus-box-outline</v-icon>
                </v-btn>
              </td>
              <td>
                {{ item.name }}
                <!-- <v-btn
                  x-small
                  class="ml-2"
                  v-if="item.id == 2"
                  color="grey"
                  outlined
                  >3 Sub Group</v-btn
                > -->
              </td>
            </template>
            <template v-slot:item.status="{ item }">
              <v-btn
                x-small
                rounded
                min-width="120"
                :color="item.status == 'active' ? 'green2' : 'red2'"
                depressed
                :class="
                  item.status == 'active'
                    ? 'primary--text' + ' ' + 'border-active'
                    : 'red--text' + ' ' + 'border-deactivated'
                "
                height="34"
              >
                {{ item.status == "active" ? "Active" : "Deactivated" }}
              </v-btn>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" style="padding: 0">
                <v-data-table
                  :loading="loading"
                  :headers="subHeaders"
                  :items="item.groupAnimals"
                  hide-default-footer
                  :single-expand="singleExpand"
                  :expanded.sync="expanded"
                  class="subHeader"
                  @pagination="paginationChanged"
                >
                  <template v-slot:item.gender="{ item }">
                    <td class="text-uppercase">{{ item.gender }}</td>
                  </template>
                  <template v-slot:item.breed="{ item }">
                    <td class="text-uppercase">{{ item.breedName }}</td>
                  </template>
                  <template v-slot:item.dateOfBirth="{ item }">
                    <td class="text-uppercase">
                      {{ item?.dateOfBirth | formatDate }}
                    </td>
                  </template>
                  <template v-slot:item.tag="{ item }">
                    <td class="text-uppercase">
                      {{
                        item?.animalIdentification?.identificationMethods
                          .tagNumber
                      }}
                    </td>
                  </template>
                  <template v-slot:item.regOfDate="{ item }">
                    <td class="text-uppercase">
                      {{
                        item?.animalIdentification?.dateOfRegistration
                          | formatDate
                      }}
                    </td>
                  </template>
                  <template v-slot:item.status="{ item }">
                    <td class="capitlize text-center">
                      <v-btn
                        x-small
                        rounded
                        min-width="120"
                        color="green2"
                        depressed
                        class="primary--text border-active"
                        height="34"
                      >
                        {{ item.status }}
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
    <ration-suggestion
      v-if="isRationSuggestion"
      :dialogI="isRationSuggestion"
      @closeDialog="isRationSuggestion = false"
      @rationPriority="setRationPriority"
    ></ration-suggestion>
    <add-group-name
      v-if="addGroupName"
      :dialogI="addGroupName"
      @closeDialog="addGroupName = false"
      @updateTable="refresTable"
    >
    </add-group-name>
    <ungrouped-animals-dialog
      v-if="unGroupedAnimals"
      :dialogI="unGroupedAnimals"
      @createGroupName="createGroupName"
      @closeDialog="unGroupedAnimals = false"
    >
    </ungrouped-animals-dialog>
    <sub-group-selection-dialog
      v-if="subGroupSelection"
      :dialogI="subGroupSelection"
      :selectedGroup="selectedGroup"
      @updateSubGroup="updateSubGroup"
      @closeDialog="subGroupSelection = false"
    >
    </sub-group-selection-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import AddGroupName from "@/views/feed_management/ration_library/DialogBox/AddGroupName";
import UnGroupedAnimals from "@/views/feed_management/ration_library/DialogBox/UnGroupedAnimals";
import SubGroupSelection from "@/views/feed_management/ration_library/DialogBox/SubGroupSelectionDialog";
import { animalGroupListForRation } from "@/graphql/Animals.gql";
import {
  generateSubGroups,
  availableQuickFilters,
  getUserIngredientDetail,
  ration,
} from "@/graphql/Feed.gql";
import LoadingMixin from "@/mixins/LoadingMixin";
import RationSuggestion from "../DialogBox/RationSuggestion.vue";

export default {
  apollo: {
    animalGroupListForRation: {
      query: animalGroupListForRation,
      update: data => data.animalGroupListForRation.rows,
      fetchPolicy: "no-cache",
      variables() {
        return {
          searchGroupListInput: {
            page: this.tableOptions.page,
            limit: this.tableOptions.limit,
            searchPhrase: this.search,
            level: this.level,
            field: this.field,
            value: this.value,
            animalForRation: true,
          },
        };
      },
      result({ data }) {
        this.loading = false;
        this.items = data.animalGroupListForRation.rows.map(row => {
          if (
            this.selectedAnimalGroups.some(group => group.groupId == row.id)
          ) {
            return { ...row, checked: true };
          } else return row;
        });
        this.totalRecord = data.animalGroupListForRation.totalRecord;
        this.totalPages = data.animalGroupListForRation.totalPages;
      },
    },
    availableQuickFilters: {
      query: availableQuickFilters,
      update: data => data.availableQuickFilters,
      fetchPolicy: "no-cache",
      variables() {
        return {};
      },
      result({ data }) {
        this.filterList = data.availableQuickFilters;
        this.loading = false;
        console.log("AVAILABLE QUICK FILTER", data);
      },
    },
  },
  components: {
    "add-group-name": AddGroupName,
    "ungrouped-animals-dialog": UnGroupedAnimals,
    "sub-group-selection-dialog": SubGroupSelection,
    "ration-suggestion": RationSuggestion,
  },
  data() {
    return {
      rationType: "",
      level: "",
      field: "",
      value: "",
      selectedAnimalGroups: [],
      selectedGroup: null,
      totalRecord: 0,
      unGroupedAnimals: false,
      addGroupName: false,
      subGroupSelection: false,
      expanded: [],
      singleExpand: false,
      menu: false,
      itemsPerPageSlider: 0,
      itemsPerPageOptions: [5, 10, 25, 50],
      to: "",
      from: "",
      totalPages: 0,
      search: "",
      selected: [],
      totalAnimals: 1,
      selectedItem: false,
      loading: false,
      length: 0,
      pageCount: 1,
      tableOptions: { page: 1, limit: 3 },
      loadingText: "Loading... Please wait",

      filterList: [],

      headers: [
        {
          text: this.$t("ration.groupName"),
          value: "data-table-expand",
          align: "start",
          class: "first-column-header",
        },
        {
          text: "",
          align: "start",
          value: "combined",
          sortable: false,
          class: "black--text",
        },

        {
          text: this.$t("ration.noOfAnimals"),
          value: "animalCounts",
          class: "black--text",
        },
        {
          text: this.$t("ration.bodyWeight"),
          value: "bodyWeight",
          class: "black--text",
        },
        {
          text: this.$t("ration.feedName"),
          value: "feedName",
          class: "black--text",
        },
        {
          text: this.$t("ration.status"),
          sortable: false,
          value: "status",
          class: "black--text",
        },
      ],
      subHeaders: [
        {
          text: this.$t("ration.id"),
          value: "id",
          class: "black--text",
          sortable: false,
        },
        {
          text: this.$t("ration.tag"),
          value: "tag",
          class: "black--text",
          sortable: false,
        },
        {
          text: this.$t("ration.dateOfBirth"),
          value: "dateOfBirth",
          class: "black--text",
          sortable: false,
        },
        {
          text: this.$t("ration.gender"),
          value: "gender",
          class: "black--text",
          sortable: false,
        },
        {
          text: this.$t("ration.breed"),
          value: "breed",
          class: "black--text",
          sortable: false,
        },
        {
          text: this.$t("ration.regDate"),
          value: "regOfDate",
          class: "black--text",
          sortable: false,
        },
        {
          text: this.$t("ration.status"),
          sortable: false,
          align: "center",
          value: "status",
          class: "black--text",
        },
      ],
      selectedHeaders: [],
      items: [],
      tableHeaders: [],
      allSelectedHeaders: [
        this.$t("ration.groupName"),
        this.$t("ration.noOfAnimals"),
        this.$t("ration.bodyWeight"),
        this.$t("ration.feedName"),
        this.$t("ration.status"),
      ],
      isRationSuggestion: false,
      rationPriority: null,
    };
  },
  async mounted() {
    this.rationType = this.$route.query.rationType;
    this.$store.commit("clearFeedState");
    this.loading = true;
    this.tableHeaders = this.headers;
    this.selectedHeaders = this.allSelectedHeaders;

    this.$apollo.queries.animalGroupListForRation.skip = false;
    this.$apollo.queries.animalGroupListForRation.refetch();
  },
  methods: {
    applyQuickFilter(item) {
      this.level = item.level;
      this.field = item.field;
      this.value = item.value;
    },
    async setRationPriority(data) {
      this.rationPriority = data;
      await this.next();
    },

    next() {
      if (this.selectedAnimalGroups.length == 0) {
        this.$notify({
          title: "Info!!!",
          text: "Please select groups with subgroups!",
          type: "info",
        });

        return;
      }
      this.$store.commit("clearFeedState");
      this.startLoading();
      const data = {
        selectedAnimalGroups: this.selectedAnimalGroups,
      };
      // this.$router.push({ name: "IngredientsGroupSelection" });
      // this.stopLoading();
      return this.$apollo
        .mutate({
          mutation: generateSubGroups,
          variables: {
            generateSubGroupsInput: data,
          },
        })
        .then(async response => {
          console.log({ response });
          this.stopLoading();
          if (response?.data) {
            this.$store.commit(
              "setRationId",
              response.data?.generateSubGroups.map(ration => {
                return ration.id;
              })
            );
            if (this.rationType == "system") {
              // do everything from IngredientsGroupSelection if its system suggested
              let ingredientsRes = await this.$apollo.query({
                query: getUserIngredientDetail,
                fetchPolicy: "no-cache",
                variables: {
                  ingredientListInput: {
                    // page: this.tableOptions.page,
                    // limit: this.tableOptions.limit,
                    // searchPhrase: this.search,
                  },
                },
              });

              let rationRes = await this.$apollo.query({
                query: ration,
                fetchPolicy: "no-cache",
                variables: {
                  id: Number(response.data.generateSubGroups.id),
                },
              });

              let animalGroupsForIngredient = [],
                rationSuggestionInput = {};
              let animalGroupsObj = {};
              animalGroupsObj.groupId =
                rationRes.data.ration.rationAnimalGroups[0].groupId;
              animalGroupsObj.subGroupIngredients = [];

              console.log("here");

              rationRes.data.ration.rationAnimalGroups[0].subGroup.forEach(
                subGrp => {
                  let ingrArr = [];

                  ingredientsRes.data.getUserIngredientDetail.rows.forEach(
                    ingre => {
                      ingrArr.push({
                        ingredientID: ingre.ingredientID,
                        quantity: ingre.quantity,
                      });
                    }
                  );

                  animalGroupsObj.subGroupIngredients.push({
                    subGroupId: +subGrp.id,
                    ingredients: ingrArr,
                  });
                }
              );

              animalGroupsForIngredient.push(animalGroupsObj);

              rationSuggestionInput.animalGroupsForIngredient =
                animalGroupsForIngredient;
              rationSuggestionInput.rationId = +rationRes.data.ration.id;

              this.$store.commit(
                "setRationSuggestionInput",
                rationSuggestionInput
              );

              this.$router.push({
                name: "RationSuggestion",
                query: {
                  rationId: +rationRes.data.ration.id,
                  rationType: this.rationType,
                  rationPriority: this.rationPriority,
                },
              });
            } else {
              this.$router.push({
                name: "IngredientsGroupSelection",
                query: {
                  rationId: response.data?.generateSubGroups.map(ration => {
                    return ration.id;
                  }),
                },
              });
            }
          } else {
            this.$notify({
              title: "Error!!!",
              text: "Could not create subgroup",
              type: "error",
            });
          }
        })
        .catch(error => {
          this.$notify({
            title: "Error!",
            text:
              (error?.graphQLErrors && error?.graphQLErrors[0].message) ||
              "Something went wrong!",
            type: "error",
          });
          this.stopLoading();
          this.stopLoading();
          Promise.reject(error);
          this.stopLoading();
        });
    },
    back() {
      this.$router.go(-1);
    },
    createGroupName() {
      this.unGroupedAnimals = false;
      this.addGroupName = true;
    },
    pageChange(t) {
      this.loading = true;
      if (t) this.tableOptions.page = Number(this.tableOptions.page) + 1;
      else this.tableOptions.page = Number(this.tableOptions.page) - 1;

      this.$router.replace({ query: { page: this.tableOptions.page } });
    },
    paginationChanged() {
      this.$router.replace({ query: { page: this.tableOptions.page } });
    },

    resetDefaut() {
      this.tableHeaders = this.headers;
      this.selectedHeaders = this.allSelectedHeaders;
      this.menu = false;
    },
    resetTableStructure() {
      this.tableHeaders = this.headers.filter(header =>
        this.selectedHeaders.includes(header.text)
      );
      this.tableOptions.limit =
        this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.menu = false;
      // this.stopLoading();
    },
    searchAnimals() {
      if (this.search == "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        // this.getTabletAnimalsData();
      } else {
        this.tableOptions.page = 1;
        // this.getAnimalsData();
      }
      this.loading = true;
      this.$apollo.queries.animalGroupListForRation.refetch();
    },
    refresTable() {
      this.$apollo.queries.animalGroupListForRation.refetch();
    },
    openDubGroupModal(item) {
      if (item.checked) {
        this.selectedGroup = item;
        this.subGroupSelection = true;
      } else {
        const dataToRemove = this.selectedAnimalGroups.findIndex(
          data => data.groupId == this.selectedGroup.id
        );
        this.selectedAnimalGroups.splice(dataToRemove, 1);
      }
    },
    updateSubGroup(data) {
      this.selectedAnimalGroups.push(data);
    },
  },
  mixins: [LoadingMixin],
};
</script>

<style lang="scss" scoped>
.border-active {
  border: 1px solid green !important;
}

.border-deactivated {
  border: 1px solid red !important;
}
:deep.subHeader .v-data-table-header {
  background-color: #fde9c7 !important;
}
::v-deep .first-column-header {
  width: 135px !important;
  min-width: 135px !important;
  padding-left: 40px !important;
}
</style>
